import type { UnknownObject } from '../../../types';

/**
 * analytics 파라미터의 boolean 값을 `'1'` / `'0'` 문자열로 정규화한다.
 *
 * 예/아니오 값은 `'1'` / `'0'` 문자열로 보내는 것이 이 앱의 규약이다(`IS_AD: isAd ? '1' : '0'`
 * 처럼 호출부가 직접 변환해 온 곳들). 반면 서버 응답을 그대로 얹는 호출부(`...logging.analytics`)
 * 는 boolean 을 손대지 않아, **같은 키가 발화 지점에 따라 `true` / `'1'` 로 섞여 올라간다**.
 * 채널(Amplitude/Firebase)에서는 타입이 다르면 다른 값으로 집계되므로 전송 직전에 한 번 맞춘다.
 *
 * 얕은 변환만 한다 — analytics 는 플랫 맵이 규약이고, 중첩 객체(`contents` 등)까지 건드리면
 * 채널별 직렬화(pixel 의 `contents` stringify 등)와 충돌한다.
 */
export const normalizeAnalyticsBooleans = (
  analytics: UnknownObject | undefined,
): UnknownObject | undefined => {
  if (analytics == null) return analytics;

  return Object.fromEntries(
    Object.entries(analytics).map(([key, value]) => [
      key,
      typeof value === 'boolean' ? (value ? '1' : '0') : value,
    ]),
  );
};
